import TableFolderPage from '@/views/tableCovers/TableFolderPage'

export default function TableFolder() {
  return <TableFolderPage />
}
